import { render, staticRenderFns } from "./MarketplaceRequestForm.vue?vue&type=template&id=5c28adbe&scoped=true&"
import script from "./MarketplaceRequestForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28adbe",
  null
  
)

export default component.exports